import { Injectable, Inject } from '@angular/core';
import { AnnotateService as IAnnotateService } from '@relevance/core';

import { AnnotateServiceConfig, ANNOTATE_CONFIG } from './annotate.config';

/**
 * This service exposes the annotate service as an Angular dependency.
 */
@Injectable()
export class AnnotateService extends IAnnotateService {

  constructor(
    @Inject(ANNOTATE_CONFIG) config: AnnotateServiceConfig,
  ) {
    super(config.url);
  }

}
